var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,9.333l5.333,2.662L10,14.667ZM24,0V24H0V0ZM20,12c-.02-4.123-.323-5.7-2.923-5.877-2.4-.164-7.754-.163-10.153,0C4.326,6.3,4.02,7.87,4,12c.02,4.123.323,5.7,2.923,5.877,2.4.163,7.75.164,10.153,0C19.674,17.7,19.98,16.13,20,12Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.7da9cb72a9684a7a013ad0e22ab706a0.svg";
export { ForwardRef as ReactComponent };